// ------------------------------------------------------------------
// Flagship project snapshots shown under the client logo wall.
// Copy is intentionally qualitative — no client-specific claims.
// ------------------------------------------------------------------

export const CASE_STUDIES = [
  {
    id: "battery-gigafactory",
    sector: "Energy & battery",
    country: "Sweden",
    title: "Battery gigafactory expansion",
    scope: "Skilled trades and on-site HSE supervision through a multi-phase battery plant build-out.",
    points: [
      "Mechanical fitters, welders and electricians mobilised in phases",
      "Permit-to-work, toolbox talks and daily site inspections",
      "Competency and certificate checks before the first shift",
    ],
    image: "/assets/industry-1.webp",
  },
  {
    id: "data-centre-fitout",
    sector: "Data centres",
    country: "Sweden",
    title: "Hyperscale data centre fit-out",
    scope: "MEP support crews and HSE oversight across a fast-track data centre construction programme.",
    points: [
      "Electrical and mechanical crews scaled to the construction curve",
      "Risk assessments and method statements for live-area works",
      "Incident reporting and corrective action follow-up",
    ],
    image: "/assets/case-datacentre.webp",
  },
  {
    id: "wind-service-campaign",
    sector: "Wind energy",
    country: "Denmark",
    title: "Wind turbine installation & service",
    scope: "Technicians for turbine installation, blade repair and seasonal service campaigns.",
    points: [
      "GWO-certified technicians for onshore and offshore scopes",
      "Working-at-height and rescue planning support",
      "Rotating crews aligned to campaign windows",
    ],
    image: "/assets/case-wind.webp",
  },
];
